export default "__VITE_ASSET__erOwUcVI__"